import React, { useEffect } from 'react'
import { IonItem, IonLabel, IonList, IonSearchbar, IonToolbar } from '@ionic/react'
import { IOption, IOptions } from '../../../common/common.types'
import { BaseSyntheticEvent, useState } from 'react'
import './SinglePickList.component.css'
import { useTranslation } from 'react-i18next'
import { ISegmentPNNVOption } from '../SegmentedSelect.component'

export interface ISinglePickListProps {
  options: IOptions
  pnnvOptions: IOptions | null
  disabledOptions: IOptions
  selectedOption: IOption | null
  selectedPNNVOption: ISegmentPNNVOption | null
  onChange: (option: IOption) => void
  onPNNVChange: (option: IOption) => void
  showPNNVs: boolean
}

const SinglePickList: React.FC<ISinglePickListProps> = (props: ISinglePickListProps) => {
  const {
    options,
    pnnvOptions,
    selectedOption,
    selectedPNNVOption = null,
    disabledOptions,
    onChange,
    onPNNVChange,
    showPNNVs,
  } = props
  const [selected, setSelected] = useState(selectedOption)
  const [filteredOptions, setFilteredOptions] = useState(options)
  const [searchValue, setSearchValue] = useState('')
  const { t } = useTranslation()

  useEffect(() => {
    setSelected(selectedOption)
  }, [selectedOption])

  const isOptionDisabled = (option: IOption) => {
    return disabledOptions.some((o) => o.id === option.id)
  }

  const onOptionClick = (e: BaseSyntheticEvent, option: IOption) => {
    e.preventDefault()
    setSelected(option)
    onChange(option)
  }

  const selectPNNVOption = (e: BaseSyntheticEvent, option: IOption) => {
    e.preventDefault()
    if (!onPNNVChange) return
    onPNNVChange(option)
  }

  const performSearch = (e: CustomEvent) => {
    const searchText = e.detail.value
    if (options) {
      const filteredOptions = options.filter((option) => option.name?.toLowerCase().includes(searchText.toLowerCase()))
      setSearchValue(searchText)
      setFilteredOptions(filteredOptions)
    }
  }

  const getPnnvSection = () => {
    return (
      showPNNVs &&
      pnnvOptions &&
      pnnvOptions.length > 0 && (
        <div className='page-pnnv-selection-section'>
          <hr className='picklist-divider' />
          <IonList>
            {pnnvOptions?.map((option: IOption) => (
              <IonItem
                key={`Option_${option.id} `}
                data-testid={`Option_${option.id}`}
                onClick={(e) => selectPNNVOption(e, option)}
                className={`${selectedPNNVOption?.id === option.id ? 'selected-pnnv-option' : ''} pnnv-option`}>
                <IonLabel id={`optionLabel_${option.id}`}>{option.name}</IonLabel>
              </IonItem>
            ))}
          </IonList>
        </div>
      )
    )
  }

  return (
    <div className='single-segment-select'>
      <IonToolbar color='light'>
        <IonSearchbar
          data-testid='SingleSearchbar'
          debounce={100}
          value={searchValue}
          onIonChange={performSearch}
          autocomplete='off'
        />
      </IonToolbar>
      <IonList class='ion-padding'>
        {filteredOptions &&
          filteredOptions.map((option) => {
            return (
              <IonItem
                key={`Option_${option.id} `}
                className='ion-no-padding ion-activatable'
                onClick={(e) => onOptionClick(e, option)}
                disabled={isOptionDisabled(option)}>
                <IonLabel className={option.id === selected?.id ? 'selected-label' : ''}>{option.name}</IonLabel>
              </IonItem>
            )
          })}
        {searchValue.length > 0 && !filteredOptions.length && (
          <IonItem key={'no_options_found'}>
            <IonLabel>
              {t('common.NoSearchResults')}
              {`"${searchValue}"`}
            </IonLabel>
          </IonItem>
        )}
      </IonList>
      {getPnnvSection()}
    </div>
  )
}

export default SinglePickList
